// one line of a streamed upload response: progress steps, then exactly one result line
export type VoortgangRegel =
    | {type: 'voortgang'; tekst: string; huidige?: number; totaal?: number}
    | {type: 'resultaat'; status: number; body: unknown};

// this content type must stay one that compression middleware treats as incompressible (verified for application/x-ndjson);
// otherwise the whole stream gets buffered by the compressor instead of flushed line by line
export const VOORTGANG_CONTENT_TYPE: string = 'application/x-ndjson';
